import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW4001Component } from './kymw4001.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW4002Module } from '../kymw4002/kymw4002.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetPromotionListService } from './api-services/get-promotion-list.service';
import { OutputPromotionListService } from './api-services/output-promotion-list.service';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';

/**
 * プロモーションマスタ一覧画面 モジュール設定クラス
 *
 * @export KYMW4001Module
 * @class KYMW4001Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    KYMW4002Module,
    WjNavModule,
    WjGridModule,
  ],
  declarations: [
    KYMW4001Component,
  ],
  providers: [
    GetPromotionListService,
    OutputPromotionListService,
  ],
})

export class KYMW4001Module { }
